module.exports = __webpack_public_path__ + "static/media/location_page.c34d767b.png";